<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-3 offset-md-3 text-right center">
                    <button type="submit" class="btn btn-primary btn-fill"
                            @click="create()">Create Gift</button>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light table-bordered table-hover"
                         :columns="gifts.columns" :data="gifts.data">
                    <template slot="table-row" v-if="gifts.data.length">
                        <tr v-for="(item, index) in gifts.data" :key="index">
                            <td>{{item.userGiftId}}</td>
                            <td><a :href="makeOnlineUrl(item)">{{makeOnlineUrl(item)}}</a></td>
                            <td>
                                <div class="btn-group" role="group">
                                  <button class="btn btn-info btn-sm" @click="edit(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>
                                    <button class="btn btn-secondary btn-sm" @click="view(item)" v-tooltip.top-center="tooltips.view"><i class="fa fa-eye"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const columns = ['Giftee Id', 'URL', 'Operations'];
    export default {
        name: 'Gifts',
        components: {
            LTable,
        },
        data() {
        return {
            tooltips: {
                view: 'View',
                edit: 'Edit'
            },
          gifts: {
                columns: [...columns],
        data: []
    }
    }
    },
    methods: {
        fetch () {
            this.$store.dispatch('FETCH_GIFTS')
                    .then((res) => {
                        this.gifts.data = res;
                        console.log("this.gifts.data : ", this.gifts.data);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
        },
        view(item){
            this.$store.commit('SET_SELECTED_GIFT', item);
            this.$router.push({ name: 'Gift Details', params: { id:  item.userGiftId}})
        },
      // editGifting(item){
      //   console.log('item to edit', item)
      //   this.$store.commit('SET_SELECTED_GIFT', item);
      //   this.$router.push({ name: 'EditGift', params: { id: item.userGiftId}});
      // },
        makeOnlineUrl(item){
          let href = window.location.href;
          let origin = (href.indexOf('dev') !== -1) ? 'https://www1.dev-tonenetworks.com/' : 'https://www.tonenetworks.com/';
          if(item.corporationId !== 4){
            return `${origin}corporation/${item.corporationId}/${item.gifteeUuid}`
          }
          else{
            return `${origin}corporation/referral/${item.corporationId}/${item.gifteeUuid}`
          }

        },
        edit(item){
            this.$store.commit('SET_SELECTED_GIFT', item);
            this.$router.push({ name: 'EditGift', params: { id: item.userGiftId}});
        },
        create(){
            this.$router.push({ name: 'Create Gift'})
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
    },
    created() {
        this.fetch();
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Gifts/Gifts.vue